import {InArrayValidator, OnlyDigitsValidator} from '@spa/validators';

import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {BaseControl, CheckboxControl, Helper, SelectControl} from 'appShared/classes';
import {Validators} from '@angular/forms';
import {UserCategoryTypesEnum} from '@spa/api';
import {SelectOptionInterface} from 'appShared/components';

export const ClientUsersUsageSettingsFormMaxConcurrentConnectionsSelector = 'maxConcurrentConnections';
export const ClientUsersUsageSettingsFormMaxL1SubscriptionsSelector = 'maxL1Subscriptions';
export const ClientUsersUsageSettingsFormMaxL2SubscriptionsSelector = 'maxL2Subscriptions';
export const ClientUsersUsageSettingsFormMarketDataUsageCategorySelector = 'marketDataUsageCategory';
export const ClientUsersUsageSettingsFormCboeRecipientIdSelector = 'CboeRecipientId';
export const ClientUsersUsageSettingsFormCboeLocationIdSelector = 'CboeLocationId';
export const ClientUsersUsageSettingsFormIsNyseAgreementSignedSelector = 'IsNyseAgreementSigned';
export const ClientUsersUsageSettingsFormIsOpraAgreementSignedSelector = 'IsOpraAgreementSigned';

const getUsageCategories = (isClientUser: boolean, isCompanyEmployee: boolean): SelectOptionInterface[] => {
    let usageCategory = [
        {
            label: Helper.textsHelper().getClientUserUsageCategoryTypes(UserCategoryTypesEnum.Pro),
            value: UserCategoryTypesEnum.Pro,
        }
    ];

    if (!isCompanyEmployee) {
        usageCategory.push({
                label: Helper.textsHelper().getClientUserUsageCategoryTypes(UserCategoryTypesEnum.NonPro),
                value: UserCategoryTypesEnum.NonPro,
            },
        );
    }

    if (!isClientUser) {
        usageCategory = [{
            label: Helper.textsHelper().getClientUserUsageCategoryTypes(UserCategoryTypesEnum.Service),
            value: UserCategoryTypesEnum.Service,
        }];
    }

    return usageCategory;
};

export const ClientUsersUsageSettingsFormControls = (
    isCompanyEmployee: boolean,
    isClientUser: boolean,
    isNyseAgreementSigned: boolean,
    isOpraAgreementSigned: boolean
): (BaseControl<string> | SelectControl | CheckboxControl)[] => {
    return [
        new BaseControl({
            name: ClientUsersUsageSettingsFormMaxConcurrentConnectionsSelector,
            value: '',
            placeholder: 'Max Concurrent Connections',
            validators: [OnlyDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersUsageSettingsFormMaxL1SubscriptionsSelector,
            value: '',
            placeholder: 'Max L1 Subscriptions',
            validators: [OnlyDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersUsageSettingsFormMaxL2SubscriptionsSelector,
            value: '',
            placeholder: 'Max L2 Subscriptions',
            validators: [OnlyDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new SelectControl({
            name: ClientUsersUsageSettingsFormMarketDataUsageCategorySelector,
            value: null,
            placeholder: 'Market Data Usage Category',
            validators: [
                Validators.required,
                InArrayValidator([UserCategoryTypesEnum.Pro, UserCategoryTypesEnum.NonPro, UserCategoryTypesEnum.Service])
            ],
            componentType: ComponentTypesEnum.Select,
            options: getUsageCategories(isClientUser, isCompanyEmployee),
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersUsageSettingsFormCboeRecipientIdSelector,
            value: '',
            placeholder: 'CBOE Recipient ID',
            validators: [OnlyDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersUsageSettingsFormCboeLocationIdSelector,
            value: '',
            placeholder: 'CBOE Location ID',
            validators: [OnlyDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new CheckboxControl({
            name: ClientUsersUsageSettingsFormIsNyseAgreementSignedSelector,
            value: isNyseAgreementSigned,
            placeholder: 'Nyse Agreement Signed',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            checked: isNyseAgreementSigned,
            color: ColorCodesEnum.Primary,
            expectBooleanValue: true
        }),
        new CheckboxControl({
            name: ClientUsersUsageSettingsFormIsOpraAgreementSignedSelector,
            value: isOpraAgreementSigned,
            placeholder: 'Opra Agreement Signed',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            checked: isOpraAgreementSigned,
            color: ColorCodesEnum.Primary,
            expectBooleanValue: true
        })
    ];
};
